export const createChartDataConversionRates = (data) => {
    if (!data)
        return { timestamps: [], values: [] };
    return {
        timestamps: data.timestamps,
        values: data.values.map((item) => item.checkoutPaid.percentage),
    };
};
